<template>
  <div v-if="allSections.length">
    <BaseButton
      v-if="isQuilterFactFind"
      text="Back to 'Fact find'"
      flat
      ripple
      class="font-weight-semi-bold d-flex back-btn back-previous__btn-link pa-0 mb-sm-5"
      icon="mdi-chevron-left"
      color="#106175"
      small
      @click="handleBackToFactFind"
    />
    <h1 class="text-center font-32 font-weight-bold primary--text main-heading">
      What level of cover would you like?
    </h1>

    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(onSubmit)">
        <div class="d-flex flex-column align-center">
          <BaseRadio
            v-model="coverType.Value"
            pslStyle="image"
            width="206px"
            height="218px"
            labelClass="font-24"
            className="base-radio-align-center radio-image__cover-type"
            :items="setItemDataUiids('CoverType', HOME_COVER_TYPE_ITEMS)"
            :rules="{
              required: {
                required: true,
                errorMessageTemplate:
                  'Please select the level of cover you would like.',
              },
            }"
            :imageStyleBorderRadius="10"
            aria-label="CoverType"
          />

          <BaseButton
            depressed
            rounded
            dense
            class="font-weight-bold font-20 pa-7 px-13"
            :class="
              $vuetify.breakpoint.lgAndUp
                ? 'continue-btn--desktop'
                : 'continue-btn--mobile'
            "
            type="submit"
            text="CONTINUE"
            height="60px"
            :color="'psorange'"
            :width="$vuetify.breakpoint.lgAndUp ? '440px' : '100%'"
          />
        </div>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { ValidationObserver } from "vee-validate";
import { QUESTIONS_MODULE, STEPS_MODULE } from "@/store/types/module-types";
import { ROUTE_NAME } from "@/constants/route.constants";
import {
  setItemDataUiids,
  HOME_COVER_TYPE_ITEMS,
} from "@/constants/component.constants.js";

import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseRadio from "@/components/BaseComponents/BaseRadio";

export default {
  name: "CoverTypePage",
  components: {
    ValidationObserver,
    BaseButton,
    BaseRadio,
  },
  data() {
    return {
      setItemDataUiids,
      HOME_COVER_TYPE_ITEMS,
      coverType: null,
    };
  },
  watch: {
    allSections() {
      this.coverType = this.questionMap.CoverType;
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["allSections", "isQuilterFactFind"]),
    ...mapState(QUESTIONS_MODULE, ["questionMap"]),
  },
  created() {
    if (this.allSections.length) {
      this.coverType = this.questionMap.CoverType;
    }
  },
  mounted() {
    this.setRestoringLastStep(false);
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["setRestoringLastStep"]),
    ...mapActions(STEPS_MODULE, ["handleResetSteps"]),
    onSubmit() {
      this.$router.push({ name: ROUTE_NAME.HOME.B2B.YOUR_DETAILS });
      this.handleResetSteps();
    },
    handleBackToFactFind() {
      this.$router.push({ name: ROUTE_NAME.HOME.B2B.FACT_FIND });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-heading {
  margin: 77px 0 42px 0;
}

.base-radio-align-center {
  display: inline-flex;
  max-width: 100%;
}

.continue-btn--desktop {
  margin: 80px 0 208px 0;
}

.continue-btn--mobile {
  margin: 80px 0 12px 0;
}
</style>
